import React from 'react';
import { useTranslation } from 'react-i18next';
import { Utils } from '../../services';
import MultiSelectField from '../MultiSelectField/MultiSelectField';

import './UserDataField.css';

const UserDataField = ({ name, includeLanguage = false }) => {
    const { t } = useTranslation();

    const fields = includeLanguage ? [...Utils.userDataFields(), 'language'] : Utils.userDataFields();

    const options = fields.map(f => {
        return {
            key: f,
            text: t(`user_data.${f}`),
            value: f
        };
    });

    return <MultiSelectField name={ name } options={ options } />
}

export default UserDataField;
